import { Flex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import Input from '@/components/Inputs/Input';

type WorkSpaceSettingsProps = {
  workspaceName: string;
  setWorkspaceName: (name: string) => void;
  onComplete: () => void;
};

const WorkspaceNameSettings = (props: WorkSpaceSettingsProps) => {
  return (
    <>
      <Input
        initFocus
        placeholder="Workspace"
        sizeType="l"
        value={props.workspaceName}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          props.setWorkspaceName(e.currentTarget.value)
        }
      />
      <Space h={272} />

      <Flex j="flex-end" a="center">
        <Button
          sizeType="l"
          style={{
            width: '200px',
          }}
          onClick={props.onComplete}
        >
          Next
        </Button>
      </Flex>
    </>
  );
};

export default WorkspaceNameSettings;
